import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class FinancialProofPendingSubmitService {
  private pendingSubmitAfterAaDownload = false;

  setPendingSubmitRequired(required: boolean): void {
    this.pendingSubmitAfterAaDownload = required;
  }

  isPendingSubmitRequired(): boolean {
    return this.pendingSubmitAfterAaDownload;
  }

  /** Blocks navigation/logout until the user submits the form. Always returns false. */
  async confirmLeaveIfPendingSubmit(): Promise<boolean> {
    await Swal.fire({
      // icon: 'warning',
      title: 'Bank Statement Fetched Successfully',
      html: `
        <ul style="text-align: left; margin: 0; padding-left: 1.25rem;">
          <li>Your bank statement details have been fetched successfully. Please submit the form to complete the financial proof process.</li>
          <li>Do not leave this page or log out until you have submitted the form.</li>
        </ul>
      `,
      confirmButtonText: 'OK',
      confirmButtonColor: '#114D84',
    });
    return false;
  }
}
